import settingsActions from '../actions/SettingsActions';

export const defaultState = {
    marketplaceProperties: {
        S3_FILE_SIZE_THRESHOLD_MB: 1024,
    },
    themes: {},
    values: {
        test_player_style: 'default',
    },
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case settingsActions.types.SETTINGS_LOAD_SUCCESS:
        return Object.assign({}, state, {
            values: action.body.values,
            themes: action.body.themes,
            marketplaceProperties: action.body.marketplaceProperties,
        });
    case settingsActions.types.SETTINGS_UPDATED:
        return Object.assign({}, state, {
            values: Object.assign({}, state.values, action.body),
        });
    default:
        return state;
    }
}
